<template>
  <div class="c-filter">
    <form v-on:submit.prevent="formSubmit">
      <div class="grid-container">
        <div class="cell">
          <label class="c-filter__heading" for="filter-search"
            >{{searchLabel || "Search by keyword:"}}</label
          >
          <div class="c-filter__search">
            <input
              class="c-filter__search-field"
              id="filter-search"
              name="searchTerm"
              type="search"
              v-model="searchTerm"
            />
            <button
              class="c-button c-button--brand"
              type="submit"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "SearchFilter",
  props: {
    searchLabel: {
      type: String,
    },
    searchTerm: {
      type: String,
    },
  },

  methods: {
    formSubmit() {
      if (this.searchTerm.length > 0) {
        this.$emit("formSearch", this.searchTerm, this.category);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/components/reportAProblem/results/SearchFilter.vue